import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import service from '../service';
import type { PartnerReferralCode } from '../types/partnerReferralCode';
import { partnerReferralCodeQueryKeys } from './usePartnerReferralCodes';

export interface DeletePartnerReferralCodeVariables {
  id: string;
}

export function useDeletePartnerReferralCode(
  options?: UseMutationOptions<
    PartnerReferralCode,
    Error,
    DeletePartnerReferralCodeVariables
  >,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationKey: ['partnerReferralCode', 'delete'],
    mutationFn: async ({ id }: DeletePartnerReferralCodeVariables) => {
      return service.deletePartnerReferralCode(id);
    },
    retry: (failureCount, error: any) => {
      const status =
        error?.status ??
        error?.response?.status ??
        error?.cause?.status ??
        null;
      const isServerOrNetwork = status == null || status >= 500;
      return failureCount < 2 && isServerOrNetwork;
    },
    ...restOptions,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({
        queryKey: partnerReferralCodeQueryKeys.all,
      });
      onSuccess?.(data, variables, context, mutation);
    },
  });
}
